import React, { useState,useRef } from 'react';
import '../Assets/Css/paintingCoating.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaTools, FaWrench, FaClipboardCheck } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import aboutPaintingImg from '../Assets/Image/paintingand-coating-img1.avif';


import paintingCtaImg from '../Assets/Image/paintingandcoating-img1.avif';
import painting1 from '../Assets/Image/industrial-painting-img1.avif';
import painting2 from '../Assets/Image/painting-3.avif';
import painting3 from '../Assets/Image/painting-img-1.avif';
import painting4 from '../Assets/Image/painting-img-2.avif';
import painting5 from '../Assets/Image/industrial-painting-img1.avif';

import coating1 from '../Assets/Image/coating-img-2.avif';
import coating2 from '../Assets/Image/pardh-paintingandcoating-img4.avif';
import coating3 from '../Assets/Image/waterproofing-control.avif';
import coating4 from '../Assets/Image/waterproofing-1.avif';
import coating5 from '../Assets/Image/coating-img-2.avif';



import waterproofingimg from '../Assets/Image/coating-img-2.avif';
import { Helmet } from 'react-helmet';

export default function PaintingCoatingServices() {
  const testimonials = [
    {
      message: "The team is responsive and skilled. They handle issues before we even notice them!",
      author: "Facility Manager",
    },
    {
      message: "Our building systems have never been more reliable. Great ongoing service!",
      author: "Admin Head",
    },
    {
      message: "Prompt, professional, and thorough maintenance staff. Highly recommended.",
      author: "Operations Manager",
    },
  ];

 
const paintingRef = useRef(null);
const coatingRef = useRef(null);

  const [selectedPaintingImage, setSelectedPaintingImage] = useState(painting5);
  const thumbnails = [painting1, painting2, painting3, painting4];

  const [selectedCoatingImage, setSelectedCoatingImage] = useState(coating2);
  const thumbnails1 = [coating1, coating2, coating3, coating4];


  return (
    <div className="mainnav min-vh-100">

      <Helmet>
        <title>Painting & Coating Services | Pradh Management Solutions</title>
        <meta
          name="description"
          content="Pradh Management Solutions offers expert industrial painting and waterproofing services for long-lasting protection, aesthetics, and durability in harsh environments."
        />
        <meta
          name="keywords"
          content="Industrial Painting, Waterproofing Services, Coating Solutions, Pradh Management, Internal External Painting, Pune Painting Services"
        />
        <meta name="author" content="Pradh Management Solutions" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://pradh.com/painting-coating" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Painting & Coating Services | Pradh Management Solutions" />
        <meta
          property="og:description"
          content="Enhance your facility's durability and appearance with Pradh's industrial painting and waterproofing services. Request a free consultation today."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pradh.com/painting-coating" />
        <meta property="og:image" content="https://pradh.com/images/painting-coating-banner.jpg" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Painting & Coating Services | Pradh Management Solutions" />
        <meta
          name="twitter:description"
          content="Expert industrial painting and waterproofing services by Pradh Management. Protect your infrastructure today."
        />
        <meta name="twitter:image" content="https://pradh.com/images/painting-coating-banner.jpg" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section5">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in">Painting & Coating Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">
            Industrial internal & external painting and waterproofing for long-lasting protection and visual appeal.
          </p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">Get in Touch</a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col md={6} className="d-flex justify-content-center align-items-center">
              <img
                src={aboutPaintingImg} // Replace with your actual image import or path
                alt="About Painting & Coating"
                className="img-fluid aboutsecimg rounded shadow mb-3"
                data-aos="zoom-in"
                data-aos-delay="100"
              />
            </Col>
            <Col md={6}>
              <h2 className="page-title text-center" data-aos="fade-up">
                Overview
              </h2>
              <p data-aos="zoom-in" data-aos-delay="100">
                At <strong style={{ color: '#04A1D3' }}>Pradh Management Solutions</strong>, we offer specialized <strong>Painting & Coating Services</strong> tailored for industrial, commercial, and large-scale infrastructure projects. Our solutions are designed not only to improve the aesthetics of your premises but also to protect against harsh environmental conditions and wear over time.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                Our team of skilled professionals is equipped to handle a wide range of surface preparation, coating applications, and waterproofing treatments. Whether it’s internal or external painting, or long-lasting industrial coatings, we use high-quality materials and advanced techniques to ensure superior finish, durability, and compliance with safety and environmental standards.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Painting & Waterproofing Services Section */}
      <section className="services-highlight-section py-5">
        <Container>
          <h2 className="page-title text-center mb-4" data-aos="fade-up" data-aos-delay="100">
            Our Painting & Coating Services
          </h2>
          <Row className="g-4 justify-content-center">

            {/* Industrial Painting */}
            <Col md={6} sm={12} data-aos="fade-up" data-aos-delay="100">
              <Card className="painting-service-card h-100 border-0 shadow-lg">
                {/* <Card.Img
                  variant="top"
                  src={selectedPaintingImage}
                  className="service-image-enhanced"
                  alt="Industrial Painting"
                /> */}
                <Card.Img
  ref={paintingRef}
  variant="top"
  src={selectedPaintingImage}
  className="service-image-enhanced"
  alt="Industrial Painting"
/>
                <Card.Body className="p-4">
                  <Card.Title className="sub-service-title text-center fs-4 fw-bold">
                    Industrial Painting Solutions
                  </Card.Title>
                  <Card.Text className="text-muted">
                    At Pradh Management Solutions, we offer end-to-end industrial painting services that enhance aesthetics, increase asset lifespan, and protect against harsh environmental conditions. Our team leverages advanced coatings and application techniques to deliver consistent, high-quality results across complex industrial surfaces.
                  </Card.Text>
                  <ul className="service-list">
                    <li>Corrosion-resistant coatings for structural durability</li>
                    <li>Protective and decorative painting for machinery & infrastructure</li>
                    <li>Custom textures and specialty finishes for operational efficiency</li>
                    <li>Solutions tailored for warehouses, factories, tanks, and pipelines</li>
                  </ul>

                  {/* Thumbnail Gallery */}
                  <div className="d-flex justify-content-center mt-3 gap-2 flex-wrap">
                    {thumbnails.map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={`Thumbnail ${idx + 1}`}
                        // onClick={() => setSelectedPaintingImage(img)}
                        onClick={() => {
  setSelectedPaintingImage(img);
  if (paintingRef.current) {
    paintingRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}}

                        style={{
                          width: '100px',
                          height: '100px',
                          objectFit: 'cover',
                          cursor: 'pointer',
                          border: selectedPaintingImage === img ? '3px solid #04A1D3' : '1px solid #ccc',
                          borderRadius: '6px',
                        }}
                      />
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Industrial Waterproofing */}
            <Col md={6} sm={12} data-aos="fade-up" data-aos-delay="200">
              <Card className="painting-service-card h-100 border-0 shadow-lg">
                {/* <Card.Img
                  variant="top"
                  src={selectedCoatingImage}
                  className="service-image-enhanced"
                  alt="Waterproofing Services"
                /> */}
                <Card.Img
  ref={coatingRef}
  variant="top"
  src={selectedCoatingImage}
  className="service-image-enhanced"
  alt="Waterproofing Services"
/>

                <Card.Body className="p-4">
                  <Card.Title className="sub-service-title text-center fs-4 fw-bold">
                    Waterproofing Services
                  </Card.Title>
                  <Card.Text className="text-muted">
                    Our industrial-grade waterproofing solutions at Pradh Management Solutions are designed to prevent water ingress and protect structural integrity. Using premium membranes, sealants, and coating systems, we ensure long-term protection from moisture, leaks, and environmental deterioration.
                  </Card.Text>
                  <ul className="service-list">
                    <li>Terrace, basement, and tank waterproofing with high-grade membranes</li>
                    <li>Crack sealing, expansion joint treatments, and anti-damp systems</li>
                    <li>UV-resistant coatings for exposed surfaces</li>
                    <li>Periodic inspection & preventive maintenance plans</li>
                  </ul>

                  {/* Thumbnail Gallery */}
                  <div className="d-flex justify-content-center mt-3 gap-2 flex-wrap">
                    {thumbnails1.map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={`Thumbnail ${idx + 1}`}
                        // onClick={() => setSelectedCoatingImage(img)}
                        onClick={() => {
  setSelectedCoatingImage(img);
  if (coatingRef.current) {
    coatingRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}}

                        style={{
                          width: '100px',
                          height: '100px',
                          objectFit: 'cover',
                          cursor: 'pointer',
                          border: selectedCoatingImage === img ? '3px solid #04A1D3' : '1px solid #ccc',
                          borderRadius: '6px',
                        }}
                      />
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>

          </Row>
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Need Expert Painting or Waterproofing?</h2>
              <p className="lead"> Elevate your facility's durability and appearance with our advanced coating solutions. Let’s discuss your requirements!</p>
              <a href="/contact" className="btn-get">Request a Free Consultation</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={paintingCtaImg}
                  alt="Industrial painting service"
                  className="img-fluid rounded shadow"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up" >What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
